/* eslint-disable no-console */
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox } from "antd";
import ChevronIcon from "../../../../Common/Svgs/ChevronIcon";
import CustomInput from "../../../../Core/Components/CustomInput";
import CloseIcon from "../../../../Common/Svgs/CloseIcon";
import { updateRequest } from "../../../../Redux/Slices/requests.slice";
import getBatteryStatus from "../../../../Utils/getBatteryStatus";
import BatteryPercentageStatus from "../../../Battery/phase3/BatteryPercentageStatus";
import { client } from "../../../../Utils/axiosClient";
import useDebounce from "../../../../Core/hooks/useDebounce";
import BatteryIcon from "../../../../Common/Svgs/BatteryIcon";

const SelectBatteries = () => {
  const dispatch = useDispatch();

  const { currentRental } = useSelector((state) => state.rentals);
  const { rentalAssigning } = useSelector((state) => state.requests);

  const [search, setSearch] = useState("");
  const [focus, setFocus] = useState(false);
  const [batteries, setBatteries] = useState([]);

  const debounceSearch = useDebounce(search, 500);

  const handleSelection = (battery) => {
    let local = rentalAssigning?.batteries || [];

    const found = local.find((item) => item.id === battery.id);

    if (found) {
      local = local.filter((item) => item.id !== battery.id);
    } else {
      local = [...local, battery];
    }

    dispatch(
      updateRequest({
        key: "rentalAssigning",
        value: { ...rentalAssigning, batteries: local },
      }),
    );
  };

  const getRentalBatteries = useCallback(
    async (params) => {
      try {
        dispatch(updateRequest({ key: "loading", value: true }));

        const response = await client.get(
          `${process.env.REACT_APP_API_URL}/rentals/get-batteries`,
          { params },
        );

        if (response.status === 200) {
          setBatteries([...response.data.result]);
        }
      } catch (error) {
        console.log(error);
        setBatteries([]);
      } finally {
        dispatch(updateRequest({ key: "loading", value: false }));
      }
    },
    [dispatch],
  );

  useEffect(() => {
    const params = { hubId: currentRental?.hubId || 0 };
    if (debounceSearch) params.searchQuery = debounceSearch;
    getRentalBatteries(params);
  }, [getRentalBatteries, debounceSearch, currentRental]);

  return (
    <div>
      <div className="bg-background-white h-full px-6">
        <div className="py-6 flex items-center gap-x-3 border-t border-light-grey">
          <button
            type="button"
            onClick={() =>
              dispatch(
                updateRequest({
                  key: "transportDetailStep",
                  value: 2,
                }),
              )
            }
          >
            <ChevronIcon className="w-5 h-5 stroke-dark-gray -rotate-180" />
          </button>

          <p className="font-poppins font-medium text-sm text-black">
            Assign batteries to accept this request
          </p>
        </div>

        <CustomInput
          intent="searchFilterItem"
          prefix={
            <img src="/assets/icons/search.svg" alt="" className="mr-2" />
          }
          value={search}
          focus={focus}
          border={focus ? "success" : "none"}
          placeholder={focus ? null : "Search Battery No."}
          onChange={(e) => setSearch(e.target.value)}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          suffix={
            search.length > 0 ? (
              <CloseIcon
                className="w-4 h-4 cursor-pointer stroke-dark-grey-text"
                onClick={() => {
                  setFocus(false);
                  setSearch("");
                }}
              />
            ) : null
          }
        />

        <div className="">
          {batteries?.length ? (
            batteries?.map((battery) => {
              const selected = rentalAssigning?.batteries?.find(
                (item) => item.id === battery.id,
              );

              return (
                <div
                  className={`flex justify-between h-10 px-6 border-b cursor-pointer hover:bg-primary-20 border-light-grey 
                  ${selected ? "bg-primary-20" : ""}`}
                  key={battery.id}
                  onClick={() => handleSelection(battery)}
                >
                  <div className="flex items-center gap-x-3">
                    <Checkbox checked={selected} />
                    <p className="text-xs font-semibold text-black capitalize font-aileron">
                      {battery.registrationNo}
                    </p>
                  </div>

                  <div className="flex items-center gap-x-12">
                    <div className="w-[112px] flex justify-end">
                      {getBatteryStatus(+battery.status)}
                    </div>

                    <div className="w-[52px]">
                      <BatteryPercentageStatus
                        detail={battery}
                        showChargingStatus={false}
                      />
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div
              className="w-full h-[60vh] flex items-center justify-center"
              // style={{ height: "200px" }}
            >
              <div className="flex flex-col gap-y-1.5 items-center justify-center">
                <div className="flex items-center justify-center h-full">
                  <div className="w-9.5 h-9.5 bg-light-grey rounded-full flex items-center justify-center">
                    <BatteryIcon className="w-6 h-6 fill-none stroke-dark-grey-text" />
                  </div>
                </div>

                <p className="font-light text-10 leading-3.75 font-poppins text-dark-grey-text">
                  Nothing to show
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SelectBatteries;
